import { useEffect, useState } from "react";
import { Column } from "../../../../interfaces/table";
import { IMeta } from "../../../../interfaces/common";
import { Button } from "@mui/material";
import { getAuditInfo } from "../../../apiHandler/aduit.service";
import { useDispatch } from "react-redux";
import { setError } from "../../../store/slices/Login";
import { convertDateObjectIntoUserReadableDate } from "../../../helpers/format";
import { setAuditLogInfo } from "../../../../store/slices/auditLog";
import { IAuditInfo } from "../../../interfaces/auditInterface";

interface IuseAuditLogModal {
  modalInfo: { name: string; id: number } | null;
  onAuditAction?: (row: any) => void;
  handleClose: () => void;
}

const useAuditLogModal = ({
  modalInfo,
  onAuditAction,
  handleClose,
}: IuseAuditLogModal) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState<IAuditInfo[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [metaInfo, setMetaInfo] = useState<IMeta | null>(null);
  useEffect(() => {
    if (modalInfo && Object.keys(modalInfo).length > 0) {
      auditApiCall({ entityId: modalInfo.id, entityName: modalInfo.name });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalInfo]);

  const auditApiCall = (params: { entityId: number; entityName: string }) => {
    setIsLoading(true);
    let modifiedRes: any[] = [];
    getAuditInfo(params)
      .then((res) => {
        if (!Array.isArray(res)) {
          modifiedRes = res.data.map((item: any) => {
            return {
              name: item?.user?.fullname,
              userEmail: item?.userEmail,
              timestamp: convertDateObjectIntoUserReadableDate(item?.timestamp),
              remarks: `${item?.remarks}`,
              allowAudit: item.action === "create" ? false : true,
              id: item?.id,
            };
          });
          setMetaInfo(res?.meta);
        }
        setRows(modifiedRes);
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      })
      .catch((err: any) => {
        dispatch(setError(err?.message || "Something wenr wrong"));
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      });
  };
  const onPageChange = (page: number) => {
    setPage(page);
  };
  const onAuditClick = (row: any) => {
    if (modalInfo) {
      dispatch(setAuditLogInfo({ id: row.id, auditName: modalInfo.name }));
      handleClose();
      if (onAuditAction) {
        onAuditAction(modalInfo);
      }
    }
  };
  const columns: Column[] = [
    {
      id: "userEmail",
      label: "User Email",
      minWidth: 100,
      key: "userEmail",
      align: "center",
      isSortable: false,
    },
    {
      id: "remarks",
      label: "Remarks",
      minWidth: 170,
      align: "center",
      key: "remarks",
      isSortable: false,
    },
    {
      id: "timestamp",
      label: "Time Stamp",
      minWidth: 100,
      align: "center",
      key: "timestamp",
      isSortable: false,
    },
    {
      id: "actions",
      label: "Actions",
      minWidth: 100,
      align: "center",
      key: "actions",
      isSortable: false,
      render: (_, row: any, index) => {
        return (
          <div className="flex justify-center items-center gap-2">
            <Button
              onClick={() => onAuditClick(row)}
              disabled={!row.allowAudit}
              variant="outlined"
            >
              Audit
            </Button>
          </div>
        );
      },
    },
  ];
  return { columns, rows, page, isLoading, onPageChange, metaInfo };
};

export default useAuditLogModal;
